import styled, { css } from 'styled-components';

export const Icon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  margin-right: 5px;
`;

export const UserItem = styled.li`
  a {
    display: flex;
    align-items: center;
    padding: 15px 20px;
    
    font-size: 16px;
    line-height: 1;
    color: inherit;
    
    transition: background-color 0.3s;
    
    &:hover {
      background-color: #f8f8f8;
      
      ${Icon} svg {
        stroke: ${({ theme }) => theme.blue};
      }
    }
  }
`;

export const LogoutButton = styled.button`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 15px 20px;
  
  color: inherit;
  
  background-color: transparent;
  border: none;
  outline: none;
  
  cursor: pointer;
  transition: background-color 0.3s;
    
  &:hover {
    background-color: #f8f8f8;
    
    ${Icon} svg {
      stroke: ${({ theme }) => theme.blue};
    }
  }
`;

export const UserList = styled.ul`
  color: ${({ theme }) => theme.black};
  white-space: nowrap;
  
  svg {
    stroke: currentColor;
    
    transition: stroke 0.3s;
  }
  
  ${({ isInNavigation, theme }) => isInNavigation && css`
    margin-bottom: 25px;
    padding: 25px 0;
    
    color: ${theme.white};
    
    border-top: 1px solid ${theme.white};
    border-bottom: 1px solid ${theme.white};
    
    ${UserItem} a,
    ${LogoutButton} {
      padding: 12px 0;
      
      &:hover {
        background-color: transparent;
    
        ${Icon} svg {
          stroke: ${theme.white};
        }
      }
    }
  `}
`;
